'use client';

import { atom } from 'recoil';

export const indexSearchPageState = atom<number>({
  key: 'indexSearchPage',
  default: 1,
});

type InstantSearchUiStateOptions = {
  query: string;
};

export const indexSearchQueryState = atom<InstantSearchUiStateOptions>({
  key: 'indexSearchQuery',
  default: { query: '' },
});
